<script setup lang="ts">
import type { AlignmentType } from '@/types/common';

const props = defineProps({
	width: {
		type: String,
		default: '',
	},
	loading: {
		type: Boolean,
		default: false,
	},
	textAlign: {
		type: String as PropType<AlignmentType>,
		default: ALIGNMENT.START,
	},
});

const slots = defineSlots();

const hasSlotContent = computed(() => !!slots.default);
const classes = computed(() => {
	if (props.textAlign) {
		return `align-${props.textAlign}`;
	}
	return '';
});
</script>

<template>
  <template v-if="hasSlotContent">
    <VSkeletonLoader
      type="paragraph"
      :class="classes"
      :loading="loading"
      :width="width"
    >
      <slot />
    </VSkeletonLoader>
  </template>
  <template v-else>
    <VSkeletonLoader
      type="paragraph"
      :class="classes"
      :loading="loading"
      :width="width"
    />
  </template>
</template>

<style scoped lang="scss">
.align {
  &-start {
    :deep(.v-skeleton-loader__paragraph) {
      justify-content: start;
    }
  }

  &-center {
    :deep(.v-skeleton-loader__paragraph) {
      justify-content: center;
    }
  }

  &-end {
    :deep(.v-skeleton-loader__paragraph) {
      justify-content: end;
    }
  }
}

:deep(.v-skeleton-loader__paragraph) {
  gap: spacings-get(3);

  >.v-skeleton-loader__text {
    margin: 0;
  }
}
</style>
